// Bash script that downloads all 120 UTM projection
// # UTM has 60 zones on north and 60 zones on south
//
//
// for i in {1..60}
// do
//     let ID=32700+$i;
//     wget "https://epsg.io/$ID.js" -O ->> results.txt
// done

// for i in {1..60}
// do
//     let ID=32600+$i;
//     wget "https://epsg.io/$ID.js" -O ->> results.txt
// done

const utms = {
	'EPSG:32701': '+proj=utm +zone=1 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32702': '+proj=utm +zone=2 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32703': '+proj=utm +zone=3 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32704': '+proj=utm +zone=4 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32705': '+proj=utm +zone=5 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32706': '+proj=utm +zone=6 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32707': '+proj=utm +zone=7 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32708': '+proj=utm +zone=8 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32709': '+proj=utm +zone=9 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32710': '+proj=utm +zone=10 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32711': '+proj=utm +zone=11 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32712': '+proj=utm +zone=12 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32713': '+proj=utm +zone=13 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32714': '+proj=utm +zone=14 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32715': '+proj=utm +zone=15 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32716': '+proj=utm +zone=16 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32717': '+proj=utm +zone=17 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32718': '+proj=utm +zone=18 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32719': '+proj=utm +zone=19 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32720': '+proj=utm +zone=20 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32721': '+proj=utm +zone=21 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32722': '+proj=utm +zone=22 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32723': '+proj=utm +zone=23 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32724': '+proj=utm +zone=24 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32725': '+proj=utm +zone=25 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32726': '+proj=utm +zone=26 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32727': '+proj=utm +zone=27 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32728': '+proj=utm +zone=28 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32729': '+proj=utm +zone=29 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32730': '+proj=utm +zone=30 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32731': '+proj=utm +zone=31 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32732': '+proj=utm +zone=32 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32733': '+proj=utm +zone=33 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32734': '+proj=utm +zone=34 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32735': '+proj=utm +zone=35 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32736': '+proj=utm +zone=36 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32737': '+proj=utm +zone=37 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32738': '+proj=utm +zone=38 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32739': '+proj=utm +zone=39 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32740': '+proj=utm +zone=40 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32741': '+proj=utm +zone=41 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32742': '+proj=utm +zone=42 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32743': '+proj=utm +zone=43 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32744': '+proj=utm +zone=44 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32745': '+proj=utm +zone=45 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32746': '+proj=utm +zone=46 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32747': '+proj=utm +zone=47 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32748': '+proj=utm +zone=48 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32749': '+proj=utm +zone=49 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32750': '+proj=utm +zone=50 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32751': '+proj=utm +zone=51 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32752': '+proj=utm +zone=52 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32753': '+proj=utm +zone=53 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32754': '+proj=utm +zone=54 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32755': '+proj=utm +zone=55 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32756': '+proj=utm +zone=56 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32757': '+proj=utm +zone=57 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32758': '+proj=utm +zone=58 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32759': '+proj=utm +zone=59 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32760': '+proj=utm +zone=60 +south +datum=WGS84 +units=m +no_defs',
	'EPSG:32601': '+proj=utm +zone=1 +datum=WGS84 +units=m +no_defs',
	'EPSG:32602': '+proj=utm +zone=2 +datum=WGS84 +units=m +no_defs',
	'EPSG:32603': '+proj=utm +zone=3 +datum=WGS84 +units=m +no_defs',
	'EPSG:32604': '+proj=utm +zone=4 +datum=WGS84 +units=m +no_defs',
	'EPSG:32605': '+proj=utm +zone=5 +datum=WGS84 +units=m +no_defs',
	'EPSG:32606': '+proj=utm +zone=6 +datum=WGS84 +units=m +no_defs',
	'EPSG:32607': '+proj=utm +zone=7 +datum=WGS84 +units=m +no_defs',
	'EPSG:32608': '+proj=utm +zone=8 +datum=WGS84 +units=m +no_defs',
	'EPSG:32609': '+proj=utm +zone=9 +datum=WGS84 +units=m +no_defs',
	'EPSG:32610': '+proj=utm +zone=10 +datum=WGS84 +units=m +no_defs',
	'EPSG:32611': '+proj=utm +zone=11 +datum=WGS84 +units=m +no_defs',
	'EPSG:32612': '+proj=utm +zone=12 +datum=WGS84 +units=m +no_defs',
	'EPSG:32613': '+proj=utm +zone=13 +datum=WGS84 +units=m +no_defs',
	'EPSG:32614': '+proj=utm +zone=14 +datum=WGS84 +units=m +no_defs',
	'EPSG:32615': '+proj=utm +zone=15 +datum=WGS84 +units=m +no_defs',
	'EPSG:32616': '+proj=utm +zone=16 +datum=WGS84 +units=m +no_defs',
	'EPSG:32617': '+proj=utm +zone=17 +datum=WGS84 +units=m +no_defs',
	'EPSG:32618': '+proj=utm +zone=18 +datum=WGS84 +units=m +no_defs',
	'EPSG:32619': '+proj=utm +zone=19 +datum=WGS84 +units=m +no_defs',
	'EPSG:32620': '+proj=utm +zone=20 +datum=WGS84 +units=m +no_defs',
	'EPSG:32621': '+proj=utm +zone=21 +datum=WGS84 +units=m +no_defs',
	'EPSG:32622': '+proj=utm +zone=22 +datum=WGS84 +units=m +no_defs',
	'EPSG:32623': '+proj=utm +zone=23 +datum=WGS84 +units=m +no_defs',
	'EPSG:32624': '+proj=utm +zone=24 +datum=WGS84 +units=m +no_defs',
	'EPSG:32625': '+proj=utm +zone=25 +datum=WGS84 +units=m +no_defs',
	'EPSG:32626': '+proj=utm +zone=26 +datum=WGS84 +units=m +no_defs',
	'EPSG:32627': '+proj=utm +zone=27 +datum=WGS84 +units=m +no_defs',
	'EPSG:32628': '+proj=utm +zone=28 +datum=WGS84 +units=m +no_defs',
	'EPSG:32629': '+proj=utm +zone=29 +datum=WGS84 +units=m +no_defs',
	'EPSG:32630': '+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs',
	'EPSG:32631': '+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs',
	'EPSG:32632': '+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs',
	'EPSG:32633': '+proj=utm +zone=33 +datum=WGS84 +units=m +no_defs',
	'EPSG:32634': '+proj=utm +zone=34 +datum=WGS84 +units=m +no_defs',
	'EPSG:32635': '+proj=utm +zone=35 +datum=WGS84 +units=m +no_defs',
	'EPSG:32636': '+proj=utm +zone=36 +datum=WGS84 +units=m +no_defs',
	'EPSG:32637': '+proj=utm +zone=37 +datum=WGS84 +units=m +no_defs',
	'EPSG:32638': '+proj=utm +zone=38 +datum=WGS84 +units=m +no_defs',
	'EPSG:32639': '+proj=utm +zone=39 +datum=WGS84 +units=m +no_defs',
	'EPSG:32640': '+proj=utm +zone=40 +datum=WGS84 +units=m +no_defs',
	'EPSG:32641': '+proj=utm +zone=41 +datum=WGS84 +units=m +no_defs',
	'EPSG:32642': '+proj=utm +zone=42 +datum=WGS84 +units=m +no_defs',
	'EPSG:32643': '+proj=utm +zone=43 +datum=WGS84 +units=m +no_defs',
	'EPSG:32644': '+proj=utm +zone=44 +datum=WGS84 +units=m +no_defs',
	'EPSG:32645': '+proj=utm +zone=45 +datum=WGS84 +units=m +no_defs',
	'EPSG:32646': '+proj=utm +zone=46 +datum=WGS84 +units=m +no_defs',
	'EPSG:32647': '+proj=utm +zone=47 +datum=WGS84 +units=m +no_defs',
	'EPSG:32648': '+proj=utm +zone=48 +datum=WGS84 +units=m +no_defs',
	'EPSG:32649': '+proj=utm +zone=49 +datum=WGS84 +units=m +no_defs',
	'EPSG:32650': '+proj=utm +zone=50 +datum=WGS84 +units=m +no_defs',
	'EPSG:32651': '+proj=utm +zone=51 +datum=WGS84 +units=m +no_defs',
	'EPSG:32652': '+proj=utm +zone=52 +datum=WGS84 +units=m +no_defs',
	'EPSG:32653': '+proj=utm +zone=53 +datum=WGS84 +units=m +no_defs',
	'EPSG:32654': '+proj=utm +zone=54 +datum=WGS84 +units=m +no_defs',
	'EPSG:32655': '+proj=utm +zone=55 +datum=WGS84 +units=m +no_defs',
	'EPSG:32656': '+proj=utm +zone=56 +datum=WGS84 +units=m +no_defs',
	'EPSG:32657': '+proj=utm +zone=57 +datum=WGS84 +units=m +no_defs',
	'EPSG:32658': '+proj=utm +zone=58 +datum=WGS84 +units=m +no_defs',
	'EPSG:32659': '+proj=utm +zone=59 +datum=WGS84 +units=m +no_defs',
	'EPSG:32660': '+proj=utm +zone=60 +datum=WGS84 +units=m +no_defs',
};

export default utms;
